import { createContext, useContext } from "react";

export type MessageType = "success" | "danger" | "warning" | "info";

export type MessageAction = {
  actionLabel?: string;
  action?: () => void;
};

export type MessageBody = {
  type: MessageType;
  title: string;
  message?: string;
  duration?: number;
  testId?: string;
} & MessageAction;

export type MessageId = number;

export type MessageInstance = MessageBody & {
  id: MessageId;
  isVisible: boolean;
  _timeoutRef?: ReturnType<typeof setTimeout>;
};
export type PredefinedMessage = Omit<MessageBody, "type">;

// All of the predefined messages are functions that take a message object
export type PredefinedNeutralMessage = (
  arg: PredefinedMessage
) => Promise<MessageId>;
export type PredefinedErrorMessage = (
  arg: PredefinedMessage
) => Promise<MessageId>;
export type PredefinedSuccessMessage = (
  arg: PredefinedMessage
) => Promise<MessageId>;
export type PredefinedWarningMessage = (
  arg: PredefinedMessage
) => Promise<MessageId>;

export type MessageContextProps = {
  clearMessage: (id: MessageId) => void;
  message: (message: MessageBody) => Promise<MessageId>;
  info: PredefinedNeutralMessage;
  danger: PredefinedErrorMessage;
  success: PredefinedSuccessMessage;
  warning: PredefinedWarningMessage;
};

/**
 * MessageContext allows us to talk to the users using toasts
 */
const MessageContext = createContext<MessageContextProps>(
  {} as MessageContextProps
);

export default MessageContext;
export const useMessages = () => useContext(MessageContext);
